<div class="w-full relative h-auto">
  <a href="tel:05191005105">
  <img src="assets/images/desk-banner.webp"  alt="پشتیبانی 24 ساعته ایران هتل آنلاین"
  class="hidden md:block w-full cursor-pointer"  />
</a>
<a href="tel:05191005105">
  <img src="assets/images/mobile-banner.webp"  
  alt="پشتیبانی 24 ساعته ایران هتل آنلاین" class="block md:hidden w-full cursor-pointer"  /> 
</a>
</div>
<iho-top-nav *ngIf="!isInMapPage" ngSkipHydration (toggleDrawer)="toggleDrawer($event)" [userDataTopNav]="userData()"
  [isLoading]="_isLoadingAuth()"></iho-top-nav>

<main class="relative" role="main">
  <router-outlet></router-outlet>
  <!-- <iho-notfound /> -->
</main>


<iho-footer *ngIf="!isInMapPage" class="mb-16 md:mb-0" [phoneNumber]="(resPhoneApi | async)?.SupportPhone"></iho-footer>

<iho-side-menu *ngIf="!isInMapPage" [isOpen]="drawerIsOpen" (toggleDrawer)="toggleDrawer($event)">
</iho-side-menu>